import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../index";

interface SessionState {
  authToken: string | null;
  mobileToken: string | null;
  editingMove: boolean;
  mover: {
    id: number | null;
    name: string | null;
  };
  user: {
    id: number | null;
    email: string | null;
    first_name: string | null;
    last_name: string | null;
  };
  getTokenFn: () => string | null;
}

const initialState: SessionState = {
  authToken: null,
  mobileToken: null,
  editingMove: false,
  getTokenFn: () => null,
  mover: {
    id: null,
    name: null,
  },
  user: {
    id: null,
    email: null,
    first_name: null,
    last_name: null,
  },
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    setAuthToken: (state, action: PayloadAction<string | null>) => {
      state.authToken = action.payload;
    },
    setMobileToken: (state, action: PayloadAction<string | null>) => {
      state.mobileToken = action.payload;
    },
    setMover: (state, action) => {
      state.mover = action.payload;
    },
    setGetTokenFn: (state, action) => {
      state.getTokenFn = action.payload;
    },
    setEditingMove: (state, action) => {
      state.editingMove = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const getEditingMove = createSelector(
  (state: RootState) => state.session.editingMove,
  (editingMove) => editingMove
);

// New selector to check if app is running in mobile app context
export const checkMobileToken = createSelector(
  (state: RootState) => state.session.mobileToken,
  (mobileToken) => mobileToken !== null
);

export const {
  setAuthToken,
  setMobileToken,
  setMover,
  setGetTokenFn,
  setEditingMove,
  setUser,
} = sessionSlice.actions;
export default sessionSlice.reducer;
